import React from 'react'
import { Breadcrumbs, Link, Typography, Box } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

const Breadcrumb = ({ items }) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize='small' />} aria-label='breadcrumb'>
        <Link
          underline='hover'
          color='inherit'
          component={RouterLink}
          to='/sales-comission-incentive'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          Sales Commission Incentive
        </Link>
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          return isLast ? (
            <Typography key={index} color='text.primary'>
              {item.label}
            </Typography>
          ) : (
            <Link
              key={index}
              underline='hover'
              color='inherit'
              component={RouterLink}
              to={item.path}
            >
              {item.label}
            </Link>
          )
        })}
      </Breadcrumbs>
    </Box>
  )
}

export default Breadcrumb
